const roles = {
    SEARCH_STRATEGIST: { name: 'SEARCH_STRATEGIST', displayName: 'Search Strategist', level: 10 },
    AGENCY_MANAGER: { name: 'AGENCY_MANAGER', displayName: 'Agency Manager', level: 50 },
    SYSTEM_ADMINISTRATOR: { name: 'SYSTEM_ADMINISTRATOR', displayName: 'System Administrator', level: 100 }
};

export default roles;
